import { render } from "./CommunicationCharacteristics.vue?vue&type=template&id=3df4b240"
import script from "./CommunicationCharacteristics.vue?vue&type=script&lang=js"
export * from "./CommunicationCharacteristics.vue?vue&type=script&lang=js"
script.render = render

export default script